import { roundNumber, createOption } from '../Utils.js';

export default function incomeDataReducer(draft, action) {
  switch (action.type) {
    case 'CREATE_DESCRIPTION': {
      const newOption = createOption(action.inputValue, action.category);
      draft.descriptions.push(newOption);
      const values = [...draft.records];
      let updatedDescription = 'description';
      values[action.index][updatedDescription] = action.inputValue;
      break;
    }
    case 'CHANGE': {
      const values = [...draft.records];
      let updatedDescription = 'description';
      let updatedValue = '';
      if(null===action.event || action.event.target===undefined) {
        if(null!==action.event) {
          updatedValue = action.event.label;
        }
      } else {
        updatedDescription = action.event.target.name;
        updatedValue = action.event.target.value;
      }
      if('monthlyAmount'===updatedDescription) {
        values[action.index][updatedDescription] = parseFloat(updatedValue);
        if (action.yearCalc) {
          values[action.index]['weeklyAmount'] = roundNumber((updatedValue*12) / 52);
        } else {
          values[action.index]['weeklyAmount'] = roundNumber(updatedValue / 4);
        }
      } else if ('weeklyAmount'===updatedDescription) {
        values[action.index][updatedDescription] = parseFloat(updatedValue);
        if (action.yearCalc) {
          values[action.index]['monthlyAmount'] = roundNumber((updatedValue * 52) / 12);
        } else {
          values[action.index]['monthlyAmount'] = roundNumber(updatedValue * 4);
        }
      } else {
        values[action.index][updatedDescription] = updatedValue;
      }
      draft.monthlyTotal = roundNumber(draft.records.reduce((acc, r) => 
        !isNaN(+r.monthlyAmount) ? +acc + +r.monthlyAmount : acc, 0))
      draft.weeklyTotal = roundNumber(draft.records.reduce((acc, r) => 
        !isNaN(+r.weeklyAmount) ? +acc + +r.weeklyAmount : acc, 0));
      break;
    }
    case 'UPDATE': {
      const values = [...draft.records];
      let updatedValue = 0.00;
      const updatedDescription = action.event.target.name;
      updatedValue = action.event.target.value===""?0.00:parseFloat(action.event.target.value);
      const rounded = roundNumber(updatedValue);
      if (updatedDescription === "monthlyAmount") {
        values[action.index]['monthlyAmount'] = rounded.toFixed(2);
        values[action.index]['weeklyAmount'] = Number(values[action.index]['weeklyAmount']).toFixed(2);
      } else {
        values[action.index]['weeklyAmount'] = rounded.toFixed(2);
        values[action.index]['monthlyAmount'] = Number(values[action.index]['monthlyAmount']).toFixed(2);
      }
      
      draft.monthlyTotal = roundNumber(draft.records.map(item => item.monthlyAmount).reduce((prev, next) => 
        +prev + +next));
      draft.weeklyTotal = roundNumber(draft.records.map(item => item.weeklyAmount).reduce((prev, next) => 
        +prev + +next));
      break;
    }
    case 'ADD': {
      const values = [
      ...draft.records.slice(0, action.index),
        {
          description: "",
          company: "",
          monthlyAmount: 0,
          weeklyAmount: 0,
        },
        ...draft.records.slice(action.index)
      ];
      draft.records = values;
      draft.monthlyTotal = roundNumber(draft.records.map(item => item.monthlyAmount).reduce((prev, next) => 
        +prev + +next));
      draft.weeklyTotal = roundNumber(draft.records.map(item => item.weeklyAmount).reduce((prev, next) => 
        +prev + +next));
      break;
    }
    case 'REMOVE': {
      const values = [...draft.records];
      values.splice(action.index, 1);
      draft.records = values;
      draft.monthlyTotal = roundNumber(draft.records.map(item => item.monthlyAmount).reduce((prev, next) => 
        +prev + +next));
      draft.weeklyTotal = roundNumber(draft.records.map(item => item.weeklyAmount).reduce((prev, next) => 
        +prev + +next));
      break;
    }
    case 'ADD_SAVED_RECORDS': {
      draft.records = action.records;
      draft.monthlyTotal = roundNumber(action.records.reduce((acc, r) => 
        !isNaN(+r.monthlyAmount) ? +acc + +r.monthlyAmount : acc, 0))
      draft.weeklyTotal = roundNumber(action.records.reduce((acc, r) => 
        !isNaN(+r.weeklyAmount) ? +acc + +r.weeklyAmount : acc, 0));
      draft.descriptions = action.descriptions;
      break;
    }
    case 'RELOAD': {
      draft = action.data;
      break;
    }
    default: {
      console.log("No action")
    }
  }
  return draft;
}
